import { render, staticRenderFns } from "./CustomerSuccess.vue?vue&type=template&id=9811231a&scoped=true"
import script from "./CustomerSuccess.vue?vue&type=script&lang=js"
export * from "./CustomerSuccess.vue?vue&type=script&lang=js"
import style0 from "./CustomerSuccess.vue?vue&type=style&index=0&id=9811231a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9811231a",
  null
  
)

export default component.exports